import Gap from '~/components/Gap';
import Pill from '~/components/Pill';
import { IListEstimate } from '~/types/estimate';

interface IEstimateStatusPillsProps {
  estimateData: IListEstimate;
}

const EstimateStatusPills = ({ estimateData }: IEstimateStatusPillsProps) => {
  if (estimateData.archived === true) {
    return (
      <div className="align-center full-width">
        <Pill variant="danger">Archived</Pill>
      </div>
    );
  }

  let dueColor: 'danger' | 'primary' | 'success' = 'danger';
  if (estimateData.payment_due_status === 'Overdue') {
    dueColor = 'danger';
  } else if (estimateData.payment_due_status === 'On Time') {
    dueColor = 'primary';
  } else {
    dueColor = 'success';
  }

  return (
    <div className="align-center">
      <Pill variant={estimateData.status === 'Sent' ? 'primary' : 'secondary'}>
        {estimateData.status}
      </Pill>
      <Gap r={8} />
      {estimateData.payment_due_status ? (
        <Pill variant={dueColor}>{estimateData.payment_due_status}</Pill>
      ) : null}
    </div>
  );
};

export default EstimateStatusPills;
